import { ArrayHelper } from '@fnv-core/utils';
import { FormConfigHelpers } from '../../formcontrols/helpers/FormConfigHelpers';
import { KenticoFormProps } from '../KenticoFormContainer';
import { getResourceString } from '../../kentico/resource-strings';
import { IFormConfig } from '../../interfaces/FormConfig';
import { IFieldControl } from '../../kentico/control/create-control';

// Controls that should always be added to the summary step
const CONTROL_TYPES_ALWAYS_SUMMARY = ['reCaptchaV2Invisible'];

export class KenticoformHelpers {
    static generateSummaryStep(component: React.Component<KenticoFormProps>, formDefinitions: { [key: string]: IFieldControl[] }, formConfig: IFormConfig) {
        if (formDefinitions === undefined) {
            return undefined;
        }

        if (component.props.pageType !== 'edit') {
          return formDefinitions;
        }

        if (formConfig.noAutoGenerateSummary) {
          return formDefinitions;
        }

        
        let summaryFields = [];
        let currentSection = '';
        let addControls = [];
        
        const moveControlsToSummary = formConfig.addFormControlsToSummary || [];
        
        let addControlNames = [];

        FormConfigHelpers.formStepsForEach(formConfig, formStep => {
            if (formStep != '_summary') {
                formDefinitions[formStep].forEach((field) => {
                    if (ArrayHelper.contains(moveControlsToSummary, field.name) || ArrayHelper.contains(CONTROL_TYPES_ALWAYS_SUMMARY, field.type)) {
                        field.section = 'summary_' + (field.section || '');
                        addControls.push(field);
                        addControlNames.push(field.name);
                    }
                });
                if (addControlNames.length > 0) { 
                    formDefinitions[formStep] = formDefinitions[formStep].filter((field) => {
                        // prevent duplicates
                        return addControlNames.indexOf(field.name) === -1;
                    });
                }
            }
        });
          
        let formCount = 0;
        FormConfigHelpers.formStepsForEach(formConfig, _ => {
            formCount++;
        });

        FormConfigHelpers.formStepsForEach(formConfig, formStep => {
            
            let editFormLinkAdded = false;

            formDefinitions[formStep].forEach((field) => {
                
                let handleField = true;
                if ((currentSection == 'summary__adres-blok' + (field.prefixVoorAdresblokVelden || '')) && field.isAdresBlokField) {
                    handleField = false;
                } else 
                if (currentSection == 'summary__adres-blok' + (field.prefixVoorAdresblokVelden || '') && !field.isAdresBlokField) {
                    currentSection = ''; // reset section after last adresblok field was added and a new field is found
                }

                if ((currentSection == '' || currentSection != field.section) && handleField) {
                    
                    // add edit links on top of each section block only if a form consists of
                    // multiple steps/forms
                    editFormLinkAdded = (formCount <= 1);

                    if (!!field.isAdresBlokField) {
                        currentSection = 'summary__adres-blok' + (field.prefixVoorAdresblokVelden || '');                            
                    } else {
                        currentSection = field.section;
                    }                        

                    let generatedSummaryFields = formDefinitions[formStep]
                        .map(field => {
                            
                            let section = field.section;
                                
                            if (!!field.isAdresBlokField) {
                                section = 'summary__adres-blok' + (field.prefixVoorAdresblokVelden || '');
                                if (field.type === 'readOnly' && field.alwaysShowSummaryField === true) {
                                    return {...field, form: formStep, id: 'id_' + field.name + '_summaryField', section : section};
                                }
                            }

                            if (field.type == 'title') {
                                return { ...field, 
                                    cssClass: field.cssClass + ' form__section-break', 
                                    id: 'id_' + field.name + '_summaryField', 
                                    section : section,
                                    label: field.summaryLabel || field.label,
                                    attachEditLinkInSummary: !!field.attachEditLinkInSummary
                                };
                            } else if (field.type === 'emailaddresslist') {
                                return {...field, readOnly: true, 
                                    isSummary: true, 
                                    form: formStep, 
                                    id: 'id_' + field.name + '_summaryField',
                                    validation: {}
                                };
                            } else if (['custom', 'submit', 'readOnly', 'title'].indexOf(field.type) === -1) {
                                let hideEditLink = true;
                                if (!editFormLinkAdded && section === currentSection) {
                                    hideEditLink = false;
                                    editFormLinkAdded = true;
                                }                                    
                                return {
                                    name: field.name + '_summaryField',
                                    id: 'id_' + field.name + '_summaryField',
                                    type: 'custom',
                                    customType: 'summary',
                                    validation: {},
                                    form: formStep,
                                    section: section,
                                    orgField: field,
                                    hideEditLink: hideEditLink,
                                    alwaysShowSummaryField: true, 
                                    visibilityCondition: field.visibilityCondition, 
                                    attachEditLinkInSummary: !!field.attachEditLinkInSummary,                               
                                    data: [
                                        {
                                            label: field.summaryLabel || field.label,
                                            viaOption: field.datasource === undefined && 
                                                field.options !== undefined && field.valueoptions !== undefined && field.type !== 'range',
                                            fields: [formStep + '.' + field.name]
                                        }
                                    ]
                                };
                            } else if (field.type === 'custom' && field.customType == 'grid') {
                                return {...field, form: formStep, id: 'id_' + field.name + '_summaryField'};
                            } else if (field.type === 'custom' && field.customType == 'titleHeadingTwo') {
                                return {...field, form: formStep, id: 'id_' + field.name + '_summaryField'};
                            } else if (field.type === 'custom' && field.customType == 'richtextcontent') {
                                return {...field, form: formStep, id: 'id_' + field.name + '_summaryField'};
                            }

                        })
                        .filter(field => {
                            return (field !== undefined && currentSection !== undefined &&
                                (field.section === currentSection));
                        });

                    summaryFields = [...summaryFields, ...generatedSummaryFields];
                }
            });
        });

        summaryFields.push({
            name: '_submit_summaryField',
            type: 'submit',
            validation: {},
            section: 'generated_summary',
            label: formConfig.summarySendButtonLabel || getResourceString('Form.Send.ButtonCaption') || 'Verzenden'
        });

        let summaryStep = '_summary';
        formDefinitions[summaryStep] = [...summaryFields, ...addControls];
        formConfig.formSteps.push(summaryStep);
        formConfig.pageSettings[summaryStep] = {
            title: formConfig.toSummaryStepButtonCaption || getResourceString('Form.ToSummaryStep.ButtonCaption') || 'Controle & verzenden',
            subtitle: ''
        };
        
        return formDefinitions;
    }
}
